module.exports = __webpack_public_path__ + "img/financial-analysis.adc88052.svg";